import { DrawingLayer } from 'business/models/DrawingLayer';
import { RandomLayerDTO } from 'business/models/Models';
import { isNullOrUndefined } from 'utils/Global';

export default class RandomExcludeList {
  public static CanPlatesBeGenerated(lyr: DrawingLayer) {
    for (const rlelRow of (lyr.layerDetail as RandomLayerDTO).randomLayerExcludeList) {
      if (
        isNullOrUndefined(rlelRow.ingredient1) ||
        isNullOrUndefined(rlelRow.ingredient2)
      ) {
        return false;
      }
    }

    return true;
  }
}
